export default "__VITE_ASSET__BtcobXPW__"